/**
 * Co-located query keys (react-patterns.md "Server State"). One place so SSE
 * invalidation and mutations reference the same keys the queries register under.
 */
export const qk = {
  me: () => ['me'] as const,
  /** Public build provenance (git sha + build time) for the app footer. Not ws-scoped. */
  version: () => ['version'] as const,
  agents: (ws: string) => ['agents', ws] as const,
  agent: (ws: string, id: string) => ['agent', ws, id] as const,
  agentVersions: (ws: string, id: string) => ['agentVersions', ws, id] as const,
  runs: (ws: string) => ['runs', ws] as const,
  // Filtered runs-list key. Shares the `qk.runs(ws)` prefix so SSE invalidation of
  // `['runs', ws]` refreshes every filter view (#112, #130). `agentId` null = "All
  // agents"; `after`/`before` null = unbounded that side of the date window.
  runsList: (
    ws: string,
    agentId: string | null,
    after: string | null = null,
    before: string | null = null,
    // v1.11.0 (#215): whether archived agents' runs are included (default false).
    includeArchived = false,
    // #263: the derived-outcome filter bucket (default 'results').
    outcome: string = 'results',
    // #299: the thread-correlation filter (null = not filtered to a thread).
    threadId: string | null = null,
  ) => ['runs', ws, agentId, after, before, includeArchived, outcome, threadId] as const,
  run: (ws: string, id: string) => ['run', ws, id] as const,
  /** Daily cost breakdown (stacked-by-agent chart) over a rolling `days` window. */
  dailyCost: (ws: string, days: number) => ['dailyCost', ws, days] as const,
  /** Workspace home-dashboard aggregate (§14) — counts, run series, top agents, cost. */
  dashboard: (ws: string) => ['dashboard', ws] as const,
  /** Operator-only, cross-tenant platform stats (§14). Not workspace-scoped. */
  platformStats: () => ['platformStats'] as const,
  /**
   * Operator-only, cross-tenant workspace list (§14.6, #278) for the operator workspace
   * dropdown. Not workspace-scoped; a non-operator's request 403s (the picker self-hides).
   */
  adminWorkspaces: () => ['adminWorkspaces'] as const,
  approvals: (ws: string) => ['approvals', ws] as const,
  approval: (ws: string, id: string) => ['approval', ws, id] as const,
  notifications: (ws: string) => ['notifications', ws] as const,
  connections: (ws: string) => ['connections', ws] as const,
  fakeEmailConnectStatus: (ws: string) => ['fakeEmailConnectStatus', ws] as const,
  googleConnectStatus: (ws: string) => ['googleConnectStatus', ws] as const,
  hubspotConnectStatus: (ws: string) => ['hubspotConnectStatus', ws] as const,
  dispatchConnectStatus: (ws: string) => ['dispatchConnectStatus', ws] as const,
  pitchreplyConnectStatus: (ws: string) => ['pitchreplyConnectStatus', ws] as const,
};
